import { Badge, Box, FieldSet, Heading, InfoIcon, Text, TextButton } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials/react';
import { ElementStatus } from '@wix/rules-panel-ui';
import { assertNever } from '@wix/seo-common-core';
import React from 'react';
import { BiCtaNames } from '../../../../../bi/types';
import { useA11yWizardAdapter } from '../../../../../hooks/use-a11y-wizard-adapter';
import { useBiLogger } from '../../../../../hooks/use-bi-logger';
import { useOpenArticleByEditorHost } from '../../../../../hooks/use-open-article-by-editor-host';
import { useSessionInfoContext } from '../../../../../hooks/use-session-info-context';
import { isClassicEditorHost, isEditor3Host } from '../../../../../utils/get-editor-host';
import { ContrastRatioLevel } from '../../types';
export const RatioDisplay = _ref => {
  let {
    index,
    status,
    ratio,
    contrastRatioLevel: ratioLevel,
    isGeneric
  } = _ref;
  const {
    locale
  } = useSessionInfoContext();
  const {
    t
  } = useTranslation();
  const biLogger = useBiLogger();
  const {
    editorHost
  } = useA11yWizardAdapter();
  const {
    openSelectedArticle
  } = useOpenArticleByEditorHost();
  const ratioText = `${new Intl.NumberFormat(locale, {
    maximumSignificantDigits: 2
  }).format(ratio)}:1`;
  return /*#__PURE__*/React.createElement(FieldSet, {
    alignment: "center",
    columns: "auto 28px",
    legend: t('accessibility-wizard.rules-list.color-contrast.ratio.label'),
    legendPlacement: "top",
    legendSize: "small"
  }, /*#__PURE__*/React.createElement(Box, {
    gap: 1,
    verticalAlign: "middle"
  }, isGeneric ? /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "bold"
  }, ratioText) : /*#__PURE__*/React.createElement(Heading, {
    size: "small"
  }, ratioText), ratioLevel === ContrastRatioLevel.Fail ? /*#__PURE__*/React.createElement(Badge, {
    size: "tiny",
    skin: "neutralDanger",
    uppercase: false
  }, t('accessibility-wizard.rules-list.color-contrast.ratio.fail')) : ratioLevel === ContrastRatioLevel.AA ? /*#__PURE__*/React.createElement(Badge, {
    size: "tiny",
    skin: "neutralSuccess",
    uppercase: false
  }, t('accessibility-wizard.rules-list.color-contrast.ratio.pass')) : ratioLevel === ContrastRatioLevel.AAA ? /*#__PURE__*/React.createElement(Badge, {
    size: "tiny",
    skin: "neutralSuccess",
    uppercase: false
  }, t('accessibility-wizard.rules-list.color-contrast.ratio.pass')) : assertNever(ratioLevel)), /*#__PURE__*/React.createElement(Box, {
    align: "center"
  }, /*#__PURE__*/React.createElement(InfoIcon, {
    content: /*#__PURE__*/React.createElement(Box, {
      direction: "vertical"
    }, /*#__PURE__*/React.createElement(Text, {
      light: isClassicEditorHost(editorHost) || isEditor3Host(editorHost),
      listStyle: "circle",
      size: "small",
      weight: "thin"
    }, t('accessibility-wizard.rules-list.color-contrast.ratio.tooltip.info'), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, t('accessibility-wizard.rules-list.color-contrast.ratio.tooltip.info.fail')), /*#__PURE__*/React.createElement("li", null, t('accessibility-wizard.rules-list.color-contrast.ratio.tooltip.info.aa')))), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(TextButton, {
      size: "small",
      skin: isClassicEditorHost(editorHost) || isEditor3Host(editorHost) ? 'light' : 'dark',
      underline: "always",
      weight: "thin",
      onClick: () => {
        openSelectedArticle(editorHost, 'editor-package-accessibility-wizard.articles-color-contrast-help');
        biLogger.taskElementCtaClick({
          ctaName: BiCtaNames.LearnAboutColorContrastRequirements,
          index,
          status: status ? ElementStatus.Passed : ElementStatus.Failed
        });
      }
    }, t('accessibility-wizard.rules-list.color-contrast.ratio.tooltip.info.learn-more'))),
    size: "small",
    tooltipProps: {
      maxWidth: '264px',
      onShow: () => biLogger.taskElementCtaClick({
        ctaName: BiCtaNames.ColorContrastRatioInfo,
        index,
        status: status ? ElementStatus.Passed : ElementStatus.Failed
      })
    }
  })));
};
//# sourceMappingURL=ratio-display.js.map